module.exports = __webpack_public_path__ + "static/media/YE.78116553.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/YE.svg
// module id = 394
// module chunks = 0